//供src/common/globalApi.js 使用
//WebSiteName: 按 src/common/globalApi.js 中webhost的定义 
import globalApi from "@/common/globalApi.js";
import _router from "@/router";

export const WebSiteName = "school";
export function InitDefaultPostParams(data){
    let schoolid = data.schoolid == undefined ? 0 : data.schoolid;
    if (!schoolid){
        schoolid = globalApi.gWebsiteSessionInfo.webSiteSchoolID;
    }
    data.schoolid = schoolid;
    
    return data;
}

